import React from "react";
import { ImNotification } from "react-icons/im";
import { BsShop } from "react-icons/bs";
import { MdLocalShipping } from "react-icons/md";
import ShippingCard from "../Cards/ShippingCard";
const SellerInformation = ({ onNext }) => {
  return (
    <div>
      <div className="w-full lg:px-16 md:px-12 px-1 mt-12">
        {/* NOtification box */}
        <div className="flex w-full items-center border py-2 px-2 border-blue-400 bg-slate-50 mb-4">
          <ImNotification className="text-blue-400 text-lg" />
          <h1 className="md:text-sm text-xs font-semibold ml-2">
            If you are facing issues on this screen, please click on the
            FEEDBACK tab below to share your views.{" "}
          </h1>
        </div>

        {/* Main container of page */}
        <div className="flex md:flex-row flex-col w-full mb-6 ">
          {/* Left side details of user */}
          <div className="profile-details basis-8/12 flex-col flex border border-transparent border-r-gray-200 ">
            {/* First details container on leftside */}
            <div className="details w-full flex">
              <div className="basis-1/4 hidden md:flex justify-center ">
                <BsShop className="md:text-6xl" />
              </div>
              <div className="flex-grow">
                <h1 className="text-lg text-red-500 font-medium py-2">
                  Tell us about your business
                </h1>
                <div className="mb-3">
                  <label
                    for="storename"
                    className="block mb-1 text-sm font-semibold text-gray-900 "
                  >
                    Store name
                  </label>
                  <input
                    type="text"
                    id="storename"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-sm  focus:border-blue-500 outline-none block md:w-48 w-full px-2.5 py-2 placeholder-gray-400 "
                    placeholder="xyzs store"
                    required=""
                  />
                </div>
                <div className="shop prodct category mb-2">
                  <label
                    for="product-type"
                    class="block mb-2 text-sm font-medium text-gray-900 "
                  >
                    Shop product category
                  </label>
                  <select
                    id="product-type"
                    class="bg-gray-50 border border-gray-300 text-gray-900 text-sm md:w-48 w-full focus:border-blue-400 block p-2 "
                  >
                    <option selected>Compute & accesorries</option>
                    <option value="US">groccery</option>
                    <option value="CA">Jewellery</option>
                    <option value="FR">Sports products</option>
                    <option value="DE">Germany</option>
                  </select>
                </div>
                <div>
                  <h1 className="text-gray-500 text-md font-medium mb-2">
                    Enter your address
                  </h1>
                  <div class="flex items-center mb-2">
                    <input
                      id="adress1"
                      type="checkbox"
                      value=""
                      class="w-4 h-4 text-red-600 bg-gray-100 rounded border-gray-300 focus:ring-blue-500  focus:ring-2 "
                    />
                    <label for="adress1" class="ml-2 text-sm  text-gray-900 ">
                      Gandhi institute for technology,Gift At,Gramadiha, Po,
                      Bhubaneswar, Odisha, 754432,IN
                    </label>
                  </div>
                  <button className="text-green-600 border text-sm border-green-400 px-2 py-1 hover:bg-green-100 ">
                    Add a new address
                  </button>
                  <h1 className="text-gray-500 font-medium text-sm py-2 ">
                    Your PIN Code is eligible for Apna App easy ship.{" "}
                    <button className="text-xs text-blue-400">
                      Enter alternate pickup address
                    </button>
                  </h1>
                </div>
              </div>
            </div>
            {/* Second details container on leftside */}
            <div className="shipping w-full flex">
              <div className="basis-1/4 hidden md:flex justify-center ">
                <MdLocalShipping className="text-6xl" />
              </div>
              <div className="flex-grow">
                <h1 className="text-lg text-red-500 font-medium py-2">
                  Shipping options
                </h1>
                <ShippingCard heading={"Apna App easy ship service"} />
                <ShippingCard heading={"Ship using your own courier"} />
                <div className="w-full mt-4">
                  <button
                    onClick={onNext}
                    className=" text-white bg-amber-500 hover:bg-amber-500/90 focus:outline-none font-medium rounded-sm text-sm md:w-56 w-full  px-5 py-2 text-center "
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Faq questions on right side */}
          <div className="Faq flex-grow">
            <div className="FAQ w-full   md:px-6 px-2">
              <div className="w-full h-full  py-3 px-3">
                <h1 className="text-lg font-bold text-amber-400 mb-4">FAQ</h1>
                <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                  <button className="text-left">
                    {" "}
                    I don't have GSTIN registration number. What can i do?
                  </button>
                </h1>
                <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                  <button className="text-left">
                    {" "}
                    I have a composite GSTIN, can i sell on Apna App ?
                  </button>
                </h1>
                <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                  <button className="text-left">
                    {" "}
                    Isell goods which are exempted from GST. Do i still need to
                    apply for GSTIN certificate?
                  </button>
                </h1>
                <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                  <button className="text-left">
                    {" "}
                    where will my GSTIN information be used ?
                  </button>
                </h1>
                <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                  <button className="text-left">
                    {" "}
                    Why is my PAN/GSTIN non-editable ?{" "}
                  </button>
                </h1>
                <h1 className="px-2 text-blue-400 font-medium text-xs py-2 border border-transparent border-b-gray-300">
                  <button className="text-left">
                    {" "}
                    Which PAN should i enter ?
                  </button>
                </h1>
              </div>
            </div>
          </div>
        </div>
        <div className="flex w-full items-center border py-2 px-2 border-blue-400 bg-slate-50 mb-4">
          <ImNotification className="text-blue-400 text-lg" />
          <h1 className="md:text-sm text-xs font-semibold ml-2">
            If you are facing issues on this screen, please click on the
            FEEDBACK tab below to share your views.{" "}
          </h1>
        </div>
      </div>
    </div>
  );
};

export default SellerInformation;
